import { TextType } from '../../Text/TextTypes';
import { ColorType } from '../../styles/types';

export const TEXT_LINK =
  'cursor-pointer active:text-secondary-light sm:hover:text-secondary-light';

export const TEXT_LINK_PARAGRAPH = 'underline';
export const TEXT_LINK_BREADCRUMB = 'active:underline sm:hover:underline';

export const LABEL_TYPES: {
  [key: string]: TextType;
} = {
  level1: 'link',
  level2: 'label',
  level3: 'label',
  'button-main': 'button',
  button: 'button',
  body1: 'body1',
  body2: 'body2',
  body3: 'body3',
  body4: 'body4',
  legals: 'legals',
  breadcrumb: 'body4',
};

export const COLORS: {
  [key: string]: ColorType;
} = {
  level1: 'secondary-main',
  level2: 'secondary-main',
  level3: 'base-lighter',
  'button-main': 'secondary-main',
  button: 'base-lighter',
  body1: 'secondary-main',
  body2: 'secondary-main',
  body3: 'secondary-main',
  legals: 'secondary-main',
  breadcrumb: 'base-lighter',
};
